import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Animated, View, StyleSheet } from 'react-native'
import { LinearGradient } from 'expo-linear-gradient'
import { ShimmerTheme } from '../../../../themeConstants'

const DEFAULT_BASE = (ShimmerTheme && ShimmerTheme.baseColor) || '#E9ECEF'
const DEFAULT_HIGHLIGHT = (ShimmerTheme && ShimmerTheme.highlightColor) || '#F5F7F9'
const DEFAULT_DURATION = (ShimmerTheme && ShimmerTheme.duration) || 1200

export default function Shimmer({
  style,
  borderRadius = 8,
  duration = DEFAULT_DURATION,
  baseColor = DEFAULT_BASE,
  highlightColor = DEFAULT_HIGHLIGHT,
}) {
  const translate = useRef(new Animated.Value(0)).current
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const anim = Animated.loop(
      Animated.sequence([
        Animated.timing(translate, { toValue: 1, duration, useNativeDriver: true }),
        Animated.timing(translate, { toValue: 0, duration: 0, useNativeDriver: true }),
      ]),
    )
    anim.start()
    return () => anim.stop()
  }, [duration, translate])

  const onLayout = (e) => {
    const w = e?.nativeEvent?.layout?.width || 0
    if (w && w !== width) setWidth(w)
  }

  const gradientWidth = useMemo(() => (width > 0 ? Math.max(40, Math.floor(width * 0.4)) : 120), [width])
  const translateRange = useMemo(() => (width > 0 ? width + gradientWidth : 240), [width, gradientWidth])

  const translateX = translate.interpolate({
    inputRange: [0, 1],
    outputRange: [-gradientWidth, translateRange],
  })

  return (
    <View style={[styles.container, { borderRadius, backgroundColor: baseColor }, style]} onLayout={onLayout}>
      <Animated.View style={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: gradientWidth,
        transform: [{ translateX }],
      }}>
        <LinearGradient
          colors={[baseColor, highlightColor, baseColor]}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 1, y: 0.5 }}
          style={{ flex: 1, borderRadius }}
        />
      </Animated.View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
})
